import PropTypes from "prop-types";
import { Box, Chip, TextField, InputAdornment, IconButton } from "@mui/material";
import { History, Search, Clear } from "@mui/icons-material";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import DataTable from "shared/components/Tables/DataTable";
import { historicoColumns } from "../tables/tableConfig";

export default function MovementHistory({ historico, searchQuery, onSearchChange }) {
  const filteredHistorico = historico.filter((item) => {
    if (!item) return false;
    if (!searchQuery.trim()) return true;
    const q = searchQuery.toLowerCase();
    return [item.cedula, item.nombre, item.serie, item.marca, String(item.ganchoId || "")]
      .filter(Boolean)
      .some((f) => String(f).toLowerCase().includes(q));
  });

  const historicoRows = filteredHistorico.map((item, idx) => ({
    id: item?.id || idx + 1,

    // Usuario
    id_user: item?.id_user,
    nombre: item?.nombre || "",
    cedula: item?.cedula || "",
    celular: item?.celular || "",

    // Bicicleta
    id_byke: item?.id_byke,
    serie: item?.serie || "",
    color: item?.color || "",
    marca: item?.marca || "",

    // Ciclo
    ganchoId: item?.ganchoId || null,
    entrada: item?.entrada || null,
    salida: item?.salida || null,
    tieneSalida: Boolean(item?.salida),
  }));

  return (
    <Box>
      <MDBox p={2}>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
        >
          <MDBox display="flex" alignItems="center" gap={1.5}>
            <History sx={{ color: "#1a237e" }} />
            <MDTypography variant="h6" fontWeight="bold" sx={{ color: "#1e293b" }}>
              Histórico de Movimientos
            </MDTypography>
            <Chip
              size="small"
              label={`${filteredHistorico.length} registros`}
              sx={{ bgcolor: "#e2e8f0", color: "#1e293b", fontWeight: 600 }}
            />
          </MDBox>
          <MDBox display="flex" alignItems="center" gap={1}>
            <TextField
              size="small"
              placeholder="Buscar..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              sx={{ width: 200 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ fontSize: 18, color: "#94a3b8" }} />
                  </InputAdornment>
                ),
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => onSearchChange("")}>
                      <Clear sx={{ fontSize: 16 }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </MDBox>
        </MDBox>
      </MDBox>

      <DataTable
        table={{ columns: historicoColumns, rows: historicoRows }}
        isSorted={true}
        entriesPerPage={8}
        showTotalEntries={true}
        noEndBorder
        canSearch={false}
      />
    </Box>
  );
}
MovementHistory.propTypes = {
  historico: PropTypes.array.isRequired,
  searchQuery: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
};
